import { PrintOptionsInfo } from '@Hooks/Documents';
import { ContextMenu, Button, defaultIconSize, FlexColumn } from '@synqo/frontend-component-library';
import { IconPrinter, IconFile } from '@tabler/icons-react';

export interface PrintOptionsMenuProps extends PrintOptionsInfo {
    disabled?: boolean;
}

export const PrintOptionsMenu = ({
    printOptions,
    setCurrentPrintOption,
    hasPrintOptions,
    disabled,
}: PrintOptionsMenuProps) => {
    if (!hasPrintOptions) {
        return undefined;
    }

    if (printOptions.length === 1) {
        const option = printOptions[0];
        return (
            <Button
                key={option.id}
                appearance="transparent"
                label={`${option.display_string} drucken`}
                tooltip={`${option.display_string} drucken`}
                onClick={() => setCurrentPrintOption(option)}
                locked={disabled}
            >
                <IconPrinter size={defaultIconSize} />
            </Button>
        );
    } else {
        return (
            <ContextMenu key="ctx_print_option" icon={IconPrinter} name="print_options" locked={disabled}>
                <FlexColumn justify="start" align="stretch">
                    {printOptions.map((option) => (
                        <Button
                            key={option.id}
                            appearance="filled"
                            onClick={() => setCurrentPrintOption(option)}
                            locked={disabled}
                        >
                            <IconFile size={defaultIconSize} />
                            &nbsp;{option.display_string + ' drucken'}
                        </Button>
                    ))}
                </FlexColumn>
            </ContextMenu>
        );
    }
};
